export default {
  data() {
    return {
      isInstall: false
    };
  },
  methods: {
    isInstallUpdate(bool) {
      this.isInstall = bool;
    }
  }
};
